/**
 * IconCircle - circular icon badge element.
 * Custom element: <icon-circle>
 *
 * Loading: lazy-loaded by the theme loader (theme.js), which imports this
 * file by its exact name - the filename is load-bearing (import map in
 * snippets/theme-head.liquid).
 * Reconstructed to readable identifiers from the original minified vendor
 * bundle; behaviour verified unchanged by AST alpha-equivalence.
 */
var defineProperty = Object.defineProperty;
var setFunctionName = (target, functionName) => defineProperty(target, "name", {
  value: functionName,
  configurable: !0
});
import { ThemeComponent } from "./theme.js";
import "./vendor.js";
class IconCircle extends ThemeComponent {
  setToActive() {
    this.classList.add("is-active");
  }
  setToInactive() {
    this.classList.remove("is-active");
  }
}
setFunctionName(IconCircle, "IconCircle");
const propertyTypes = {};
IconCircle.prototype.$name = "IconCircle";
IconCircle.prototype.$info = JSON.parse('{"name":"IconCircle","meta":{"isLegacy":false,"selector":"icon-circle"},"props":[],"refs":[]}');
IconCircle.prototype.$info.component = IconCircle;
for (const prop of IconCircle.prototype.$info.props) prop.propertyType = propertyTypes[prop.propertyType];
window.componentService.registerComponent("Icon/IconCircle.ts", {
  IconCircle: IconCircle
}, void 0);